export default __webpack_public_path__ + "static/media/address-small.9410b338.svg";